/** Parsers/helpers for wallet API response shapes (copied/adapted from lotus-web). */

/** List response shape: { status: true, data: [] } */
export function walletDataItems(res) {
  if (res?.status !== true || !Array.isArray(res.data)) return [];
  return res.data;
}

/** /user/getUserShoutPeWalletLimit: { status:true, data:{ withdraw_min_limit, withdraw_max_limit, ... } } */
export function withdrawLimitsFromResponse(res) {
  if (res?.status !== true || res.data == null || typeof res.data !== "object") {
    return { withdraw_min_limit: null, withdraw_max_limit: null };
  }
  return {
    withdraw_min_limit: res.data.withdraw_min_limit,
    withdraw_max_limit: res.data.withdraw_max_limit,
  };
}

function isTruthyFlag(v) {
  return v === true || v === 1 || v === "1" || v === "true";
}

function isFalsyFlag(v) {
  return v === false || v === 0 || v === "0" || v === "false" || v == null;
}

export function isWalletTypeRow(row) {
  // Backends vary: {status:true|1|"true"} and {is_deleted:false|0|"0"|undefined}
  return isTruthyFlag(row?.status) && isFalsyFlag(row?.is_deleted);
}

export function isWalletAccountRow(row) {
  return isTruthyFlag(row?.status) && isFalsyFlag(row?.is_deleted);
}

export function getWalletEntityId(entity) {
  if (!entity || typeof entity !== "object") return "";
  return entity._id ?? entity.id ?? "";
}

export function getWalletApiErrorMessage(err) {
  if (!err) return "Something went wrong";
  if (typeof err === "string") return err;
  return (
    err?.msg ||
    err?.message ||
    err?.data?.msg ||
    err?.response?.data?.msg ||
    err?.response?.data?.message ||
    "Something went wrong"
  );
}

export function parseBankAccountsFromResponse(res) {
  return walletDataItems(res).filter(isWalletAccountRow);
}

